














import axios from 'axios';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  data: () => ({
    posts: [],
    error: false
  }),
})
export default class News extends Vue {
  @Prop({
    type: String,
    required: true,
  })
  private backend!: string;

  private posts!: string[];
  private error!: boolean;

  public mounted() {
    axios
      .get(this.backend + '/facebook')
      .then((v) => {
        this.posts = v.data;
        FB.init({
          xfbml: true,
          version: 'v3.2',
        });
        this.error = false
      })
      .catch((v) => {
        // tslint:disable-next-line:no-console
        console.log('Error loading posts', v);
        this.error = true
      });
  }

private width() {
  const a = $(window).width();

  if (a && a > 750) {
    return 750;
  } else {
    return a;
  }
}
}
